"use strict";

function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }

function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }

function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }

function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) { n[e] = r[e]; } return n; }

Object.defineProperty(exports, "__esModule", {
  value: true
});

function _export(target, all) {
  for (var name in all) {
    Object.defineProperty(target, name, {
      enumerable: true,
      get: all[name]
    });
  }
}

_export(exports, {
  dim: function dim() {
    return _dim;
  },
  default: function _default() {
    return _default2;
  }
});

var _picocolors = /*#__PURE__*/_interop_require_default(require("picocolors"));

function _interop_require_default(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var alreadyShown = new Set();

function log(type, messages, key) {
  if (typeof process !== "undefined" && process.env.JEST_WORKER_ID) return;
  if (key && alreadyShown.has(key)) return;
  if (key) alreadyShown.add(key);
  console.warn("");
  messages.forEach(function (message) {
    return console.warn(type, "-", message);
  });
}

function _dim(input) {
  return _picocolors.default.dim(input);
}

var _default2 = {
  info: function info(key, messages) {
    log.apply(void 0, [_picocolors.default.bold(_picocolors.default.cyan("info"))].concat(_toConsumableArray(Array.isArray(key) ? [key] : [messages, key])));
  },
  warn: function warn(key, messages) {
    log.apply(void 0, [_picocolors.default.bold(_picocolors.default.yellow("warn"))].concat(_toConsumableArray(Array.isArray(key) ? [key] : [messages, key])));
  },
  risk: function risk(key, messages) {
    log.apply(void 0, [_picocolors.default.bold(_picocolors.default.magenta("risk"))].concat(_toConsumableArray(Array.isArray(key) ? [key] : [messages, key])));
  }
};